;(function () {
  function setRfs() {
    var designWidth = 750
    var rem2px = 100
    console.log("window.innerWidth", window.innerWidth)
    console.log("document.documentElement.clientWidth", document.documentElement.clientWidth)

    document.documentElement.style.fontSize =
      Math.max(
        (window.innerWidth / designWidth) * rem2px,
        (document.documentElement.clientWidth / designWidth) * rem2px,
        42.67
      ) + "px"

    console.log("document.documentElement.style.fontSize", document.documentElement.style.fontSize)
  }
  setRfs()
  var tid
  console.log("before resize")
  window.addEventListener(
    "resize",
    function () {
      console.log("emit resize")
      clearTimeout(tid)
      tid = setTimeout(setRfs, 100)
    },
    false
  )
})()
